import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  shadow?: boolean;
  glass?: boolean;
  hover?: boolean;
}

export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  padding = 'md',
  shadow = true,
  glass = false,
  hover = false
}) => {
  const paddingClasses = {
    none: '',
    sm: 'p-3',
    md: 'p-6',
    lg: 'p-8'
  };
  
  return (
    <div
      className={`
        rounded-xl border transition-all duration-200
        ${glass ? 'glass-effect' : 'bg-black-800 border-gray-700'}
        ${shadow ? 'shadow-lg' : ''}
        ${hover ? 'hover:scale-[1.02] hover:shadow-xl hover:border-gold-500/30' : ''}
        ${paddingClasses[padding]}
        ${className}
      `}
    >
      {children}
    </div>
  );
};